/**
 * Navigation Module
 *
 */

import { AnchorScroll } from "./AnchorScroll.js";

//------------------------------------------------------------------------------------------------------------------
// ::: CONSTANTS
//------------------------------------------------------------------------------------------------------------------


//------------------------------------------------------------------------------------------------------------------
// ::: PUBLIC VARIABLES
//------------------------------------------------------------------------------------------------------------------


//------------------------------------------------------------------------------------------------------------------
// ::: PRIVATE VARIABLES
//------------------------------------------------------------------------------------------------------------------


//------------------------------------------------------------------------------------------------------------------
// ::: GETTERS & SETTERS
//------------------------------------------------------------------------------------------------------------------


//------------------------------------------------------------------------------------------------------------------
// ::: PUBLIC FUNCTIONS
//------------------------------------------------------------------------------------------------------------------

const OnThisPage = {
    init: function () {
        $('.otp-header').on('click', function() {
            const otpLinkContainer = $(this).siblings('.otp-link-container');
            $('.otp-link-container').not(otpLinkContainer).removeClass('expanded');
            otpLinkContainer.toggleClass('expanded');
        })

        cacheFirstCardScrollTop();

        document.querySelectorAll('.on-this-page [data-target-id]').forEach(link => {
            link.addEventListener('click', function(event) {
                handleOnThisPageLinkClick(event, this);
            });
        });

        window.XtandiOnThisPageLinkClick = handleOnThisPageLinkClick;
    }
};

//------------------------------------------------------------------------------------------------------------------
// ::: PRIVATE FUNCTIONS
//------------------------------------------------------------------------------------------------------------------

function toggleContent(group, header) {
    const currentContent = header.nextElementSibling;
    const allContents = group.querySelectorAll('.collapsible-content');

    allContents.forEach(content => {
        if (content !== currentContent) {
            content.style.display = 'none';
        }
    });

    currentContent.style.display = currentContent.style.display === 'block' ? 'none' : 'block';
}

function navigateOnThisPageTarget(targetElement, options = {}) {
    if (!targetElement) {
        return;
    }

    const { updateHash = true, verticalOffset = 0 } = options;

    if (updateHash) {
        history.replaceState(null, '', '#' + targetElement.id);
    }

    if (hasLocalToggle()) {
        scrollLocalToggleAnchor(targetElement, verticalOffset);
    } else if (isFirstCardTarget(targetElement)) {
        scrollFirstCardAnchor(targetElement, verticalOffset);
    } else {
        scrollStandardAnchor(targetElement, verticalOffset);
    }
}

function scrollToOnThisPageTarget(targetElement, options = {}) {
    navigateOnThisPageTarget(targetElement, options);
}

function handleOnThisPageLinkClick(event, linkElement) {
    event.preventDefault();

    const targetId =
        linkElement.getAttribute('data-target-id') ||
        linkElement.getAttribute('href').substring(1);
    const targetElement = document.getElementById(targetId);
    const otpLinkContainer = linkElement.closest('.otp-link-container');

    navigateOnThisPageTarget(targetElement);

    if (window.matchMedia('(max-width: 767px)').matches && otpLinkContainer) {
        otpLinkContainer.classList.remove('expanded');
    }

    return false;
}

function handleOnThisPageHashChange() {
    const targetId = window.location.hash.replace('#', '');

    if (!targetId) {
        return;
    }

    const localNavLink = document.querySelector(
        '.on-this-page a[data-target-id="' + targetId + '"]'
    );

    if (!localNavLink) {
        return;
    }

    window.setTimeout(() => {
        navigateOnThisPageTarget(document.getElementById(targetId), {
            updateHash: false
        });
    }, 0);
}

function withUnstickiedLocalNav(callback) {
    const localNav = document.querySelector('#local-nav');
    const wasStickied = localNav?.classList.contains('stickied');

    if (wasStickied) {
        localNav.classList.remove('stickied');
    }

    const result = callback(localNav);

    if (wasStickied) {
        localNav.classList.add('stickied');
    }

    return result;
}

function getNaturalTop(element) {
    return withUnstickiedLocalNav(() => element.getBoundingClientRect().top);
}

function getNaturalDocumentTop(element) {
    return withUnstickiedLocalNav(
        () => element.getBoundingClientRect().top + window.scrollY
    );
}

function isFirstCardTarget(targetElement) {
    return !!targetElement.closest('.first-card');
}

function hasLocalToggle() {
    const localToggle = document.querySelector('#local-toggle');
    return !!(localToggle && AnchorScroll.isVisible(localToggle));
}

function getFirstCardScrollTop() {
    const localNav = document.querySelector('#local-nav');

    if (!localNav) {
        return 0;
    }

    const stickyTop = parseFloat(window.getComputedStyle(localNav).top) || 0;
    const stickyThreshold = getNaturalTop(localNav) - stickyTop;

    return Math.max(Math.floor(stickyThreshold - 8), 0);
}

function scrollFirstCardAnchor(targetElement, verticalOffset = 0) {
    if (typeof window.XtandiFirstCardScrollTop !== 'number') {
        cacheFirstCardScrollTop();
    }

    window.scrollTo({
        top: Math.max(
            (window.XtandiFirstCardScrollTop ?? getFirstCardScrollTop()) + verticalOffset,
            0
        ),
        behavior: 'smooth'
    });
}

function cacheFirstCardScrollTop() {
    if (window.scrollY > 10) {
        return;
    }

    window.XtandiFirstCardScrollTop = getFirstCardScrollTop();
}

function cacheLocalToggleFirstCardScrollTop() {
    cacheFirstCardScrollTop();
}

function getOnThisPageAnchorOffset(includeLocalNav) {
    const navWrapper = document.querySelector('.nav_wrapper');
    const localToggle = document.querySelector('#local-toggle');
    const localNav = document.querySelector('#local-nav');
    const bottoms = [];

    if (AnchorScroll.isVisible(navWrapper)) {
        bottoms.push(navWrapper.getBoundingClientRect().bottom);
    }

    if (AnchorScroll.isVisible(localToggle)) {
        const toggleTop = parseFloat(window.getComputedStyle(localToggle).top);

        if (Number.isFinite(toggleTop)) {
            bottoms.push(toggleTop + localToggle.getBoundingClientRect().height);
        }
    }

    if (includeLocalNav && AnchorScroll.isVisible(localNav)) {
        const localNavTop = parseFloat(window.getComputedStyle(localNav).top);

        if (Number.isFinite(localNavTop)) {
            bottoms.push(localNavTop + localNav.getBoundingClientRect().height);
        }
    }

    return Math.ceil(Math.max(...bottoms, 0)) + AnchorScroll.vars.buffer;
}

function scrollStandardAnchor(targetElement, verticalOffset = 0) {
    const localNav = document.querySelector('#local-nav');

    if (!localNav) {
        AnchorScroll.scrollToAnchor(targetElement);
        return;
    }

    const wasStickied = localNav.classList.contains('stickied');

    if (!wasStickied) {
        localNav.classList.add('stickied');
    }

    const targetPosition =
        targetElement.getBoundingClientRect().top +
        window.scrollY -
        getOnThisPageAnchorOffset(true) +
        verticalOffset;

    if (!wasStickied) {
        localNav.classList.remove('stickied');
    }

    window.scrollTo({
        top: Math.max(targetPosition, 0),
        behavior: 'smooth'
    });
}

function scrollLocalToggleAnchor(targetElement, verticalOffset = 0) {
    const localNav = document.querySelector('#local-nav');

    if (!localNav) {
        AnchorScroll.scrollToAnchor(targetElement, { maxAttempts: 0 });
        return;
    }

    if (targetElement.classList.contains('first-card')) {
        if (typeof window.XtandiFirstCardScrollTop !== 'number') {
            cacheLocalToggleFirstCardScrollTop();
        }

        window.scrollTo({
            top: Math.max(
                (window.XtandiFirstCardScrollTop ?? 150) + verticalOffset,
                0
            ),
            behavior: 'smooth'
        });
        return;
    }

    const wasStickied = localNav.classList.contains('stickied');

    if (!wasStickied) {
        localNav.classList.add('stickied');
    }

    const targetPosition =
        targetElement.getBoundingClientRect().top +
        window.scrollY -
        getOnThisPageAnchorOffset(true) +
        verticalOffset;

    if (!wasStickied) {
        localNav.classList.remove('stickied');
    }

    window.scrollTo({
        top: Math.max(targetPosition, 0),
        behavior: 'smooth'
    });
}

//------------------------------------------------------------------------------------------------------------------
// ::: CALLBACKS & EVENT HANDLERS
//------------------------------------------------------------------------------------------------------------------


//------------------------------------------------------------------------------------------------------------------
// ::: API
//------------------------------------------------------------------------------------------------------------------

export {
    OnThisPage,
    scrollToOnThisPageTarget,
};
